import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { signInStart } from 'redux/user/user.action';
import { Button, Form, InputGroup } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import Paths from 'util/paths';
import { sendPost } from 'util/request';
import string from 'util/string';
import Urls from 'util/urls';
import {
  focusElement,
  getFormData,
  emailValidate,
	japanesePhoneValidate,
  showToast,
} from 'util/utils';
import Modal from 'component/Modal';
import { RiEyeCloseLine } from 'react-icons/ri';
import { ImEye } from 'react-icons/im';
import './Signup.scss';
import Policy from 'page/policy/Policy';
import TermsOfUse from 'page/termsofuse/TermsOfUse';
// import PolicyModal from './PolicyModal';
// import TermsConditionsModal from './TermsConditionsModal';
import AlincoLogo from 'asset/img/alinco_logo.png';
// import StepProgressBar from 'component/StepProgressBar';
import { FaChevronLeft } from 'react-icons/fa';


const SIGNUP_STEP_BEGIN = 0;
const SIGNUP_STEP_CONFIRM = 1;
const SIGNUP_STEP_FINISH = 2;

const InputText = ({
  type = 'text',
  title,
  id,
  placeholder,
  defaultValue,
  iconClick = () => {},
  iconShow = false,
  showPassword = false,
  showClick = () => {},
  hideClick = () => {},
  handleClick = () => {},
}) => {
  const props = { id, name: id, type };

  if (!!placeholder) {
    props['placeholder'] = placeholder;
  }
	if (!!defaultValue) {
		props['defaultValue'] = defaultValue;
	}

  return (
    <>
      {!!title && type !== 'hidden' && (
        <h6
          style={{
            fontWeight: '600',
            textAlign: 'left',
            paddingLeft: '10px',
            marginTop: '10px',
            marginBottom: '5px',
          }}
        >
          {title}
        </h6>
      )}
      <InputGroup>
        <Form.Control {...props} />
        {!!iconShow &&
          (showPassword ? (
            <InputGroup.Text>
              <ImEye onClick={() => handleClick()} />
            </InputGroup.Text>
          ) : (
            <InputGroup.Text>
              <RiEyeCloseLine onClick={() => handleClick()} />
            </InputGroup.Text>
          ))}
      </InputGroup>
    </>
  );
};

const initialState = {
  email: '',
  password: '',
  passwordConfirm: '',
  usernameKanji: '',
  usernameHira: '',
  phoneNumber: '',
  otp: '',
  isLoading: false,
  isError: false,
  isAuth: false,
};

// const existingUser = {
// 	existingEmail: '',
// 	existingPassword: '',
// };
// let userExist;

const Signup = () => {
  //-------------------------------HOOKS-------------------------------------------------------------
  const dispatch = useDispatch();
  const history = useHistory();
  const [signupStep, setSignupStep] = useState(SIGNUP_STEP_BEGIN);
  const [userData, setUserData] = useState(initialState);
  const [showPassword, setShowPassword] = useState(false);
  const [showPolicyModal, setShowPolicyModal] = useState(false);
  const [showTermsConditionsModal, setShowTermConditionsModal] = useState(false);
  const [termConditionCheck, setTermConditionCheck] = useState(false);
  const [showForm1, setShowForm1] = useState(true);
  const [showForm2, setShowForm2] = useState(false);
  const [showForm3, setShowForm3] = useState(false);
  const [isPolicyChecked, setIsPolicyChecked] = useState(false);
  const [isTermsConditionChecked, setIsTermConditionChecked] = useState(false);

  //------------------------FUNCTIONS----------------------------------------------------------

	useEffect(() => {
		if (!!showForm1) {
			const timerId = setTimeout(() => {
				focusElement('#email');
			}, 10);
			return () => {
				clearTimeout(timerId);
			}
		}
	},[showForm1]);

	useEffect(() => {
		if (!!showForm2) {
			const timerId = setTimeout(() => {
				focusElement('#otp');
			},10);
			return () => {
				clearTimeout(timerId);
			}
		}
	},[showForm2]);

  const onSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (signupStep === SIGNUP_STEP_BEGIN) {
      let formData = getFormData(e.target, {
        rawCol: {
          email: true,
          usernameKanji: true,
          usernameHira: true,
          phoneNumber: true,
          password: true,
          passwordConfirm: true,
        },
      });
      if (!formData.email) {
        showToast(string.MAIL_ADDRESS_EMPTY_ERR);
        focusElement('#email');
        return;
      }
      if (!emailValidate(formData.email)) {
        showToast(string.MAIL_ADDRESS_FORMAT_ERR);
        focusElement('#email');
        return;
      }
      if (!formData.usernameKanji) {
        showToast(string.USERNAME_EMPTY_ERR);
        focusElement('#usernameKanji');
        return;
      }
      if (!formData.usernameHira) {
        showToast(string.FURIGANA_EMPTY_ERR);
        focusElement('#usernameHira');
        return;
      }
      if (!formData.phoneNumber) {
        showToast(string.PHONENUMBER_EMPTY_ERR);
        focusElement('#phoneNumber');
        return;
      }
			if (!japanesePhoneValidate(formData.phoneNumber)) {
        showToast(string.PHONENUMBER_FORMAT_ERR);
        focusElement('#phoneNumber');
        return;
			}
      if (!formData.password) {
        showToast(string.PASSWORD_EMPTY_ERR);
        focusElement('#password');
        return;
      }
			if (!formData.passwordConfirm) {
				showToast(string.CONFIRM_PASSWORD_EMPTY_ERR);
				focusElement('#passwordConfirm');
				return;
			}
			if (formData.password !== formData.passwordConfirm) {
				showToast(string.PASSWORD_CONFIRM_ERR);
				focusElement('#password');
				return;
			}
      // if (!showPassword) {
      //   if (!formData.passwordConfirm) {
      //     showToast(string.CONFIRM_PASSWORD_EMPTY_ERR);
      //     focusElement('#passwordConfirm');
      //     return;
      //   }
      //   if (formData.password !== formData.passwordConfirm) {
      //     showToast(string.PASSWORD_CONFIRM_ERR);
      //     focusElement('#password');
      //     return;
      //   }
      // }
      if (!termConditionCheck) {
        showToast(string.POLICY_UNCHECK_ERR);
        focusElement('#checkbox_2');
        return;
      }

      sendPost({
        url: Urls.account.signup,
        body: {
          ...formData,
        },
        withToken: false,
      })
        .then((res) => {
          setSignupStep(SIGNUP_STEP_CONFIRM);
          setShowForm1(false);
          setShowForm2(true);
          setShowForm3(false);

          let confirmState = userData;
          confirmState.email = formData?.email;
          confirmState.password = formData?.password;
          confirmState.passwordConfirm = formData?.passwordConfirm;
          confirmState.usernameHira = formData?.usernameHira;
          confirmState.usernameKanji = formData?.usernameKanji;
          confirmState.phoneNumber = formData?.phoneNumber;
          setUserData(confirmState);
        })
        .catch((e) => {
          //console.log(e);
          const message = e;
          if (message === string.MAIL_ADDRESS_EXIST_ERR) {
            focusElement('#email');
          }
        });
    } else if (signupStep === SIGNUP_STEP_CONFIRM) {
      let formData = getFormData(e.target, {
        rawCol: {
          otp: true,
        },
      });
      if (!formData.otp) {
        showToast(string.OTP_EMPTY_ERR);
        focusElement('#otp');
        return;
      }
			const otp = {
				otp: formData.otp.toUpperCase(),
			};
      sendPost({
        url: Urls.account.signupvalidateotp,
        body: {
          ...otp,
          email: userData?.email,
          //otp: formData?.otp,
        },
        withToken: false,
      })
        .then((res) => {
          setSignupStep(SIGNUP_STEP_FINISH);
          setShowForm1(false);
          setShowForm2(false);
          setShowForm3(true);

          let finishState = userData;
          finishState.otp = formData?.otp;
          setUserData(finishState);
          //history.push(Paths.user.login);
        })
        .catch((e) => {
          //console.log(e);
          const message = e;
          if (message === string.SIGNUP_OPT_ERR) {
            focusElement('#otp');
          }
        });
    } else {
      let loginData = {
        email: userData?.email,
        password: userData?.password,
      };
      await dispatch(signInStart(loginData));
      history.push(Paths.root);
    }
  };
	const onChange = async (e) => {
		// console.log(e.target.value);
		// console.log(e.target.id);

		let confirmState = userData;
		let id = e.target.id;
		let value = e.target.value;
		if (id === 'email') {
			confirmState.email = value;
			setUserData(confirmState);
		} else if (id === 'password') {
			confirmState.password = value;
			setUserData(confirmState);
		} else if (id === 'passwordConfirm') {
			confirmState.passwordConfirm = value;
			setUserData(confirmState);
		} else if (id === 'usernameHira') {
			confirmState.usernameHira = value;
			setUserData(confirmState);
		} else if (id === 'usernameKanji') {
			confirmState.usernameKanji = value;
			setUserData(confirmState);
		} else if (id === 'phoneNumber') {
			confirmState.phoneNumber = value;
			setUserData(confirmState);
		}
	};

  const onClick = () => {
    let passwordShow = !showPassword;
    setShowPassword(passwordShow);
  };
	const onPolicyClick = () => {
		setShowPolicyModal(true);
		setShowForm1(false);
	};
  const closePolicyModal = () => {
    setShowPolicyModal(false);
		setShowForm1(true);
    setIsPolicyChecked(true);
		// setTimeout(() => {
		// 	focusElement('#email');
		// }, 10);
  };
	const onTermsConditionsClick = () => {
		setShowTermConditionsModal(true);
		setShowForm1(false);
	};
  const closeTermsConditionsModal = () => {
    setShowTermConditionsModal(false);
		setShowForm1(true);
    setIsTermConditionChecked(true);
		// setTimeout(() => {
		// 	focusElement('#email');
		// }, 10);
  };

  //------------------------------------RETURN---------------------------------------------------------
  return (
    <>
      <div className="screen-signup">
        <div className="wrapper fadeInDown">
					<div id='logoBox'>
						<img
							alt="layout"
							width="60%"
							height="60%"
							src={AlincoLogo}
						/>
					</div>
          <div id="formContent">
            <h2 className="active">{string.SIGNUP_TITLE}</h2>
            <div className="card-body">
              {/* <StepProgressBar /> */}
              <Form
								onSubmit={onSubmit}
								onChange={!!showForm1?onChange:null}
							>
                {showForm1 && (
                  <>
                    <InputText
                      title={string.SIGNUP_MAIL_TITLE}
                      id="email"
                      placeholder={string.SIGNUP_MAIL_SAMPLE}
											defaultValue={!!userData?.email ? userData.email : null}
                    />
                    <InputText
                      title={string.SIGNUP_NAME_TITLE}
                      id="usernameKanji"
                      placeholder={string.SIGNUP_NAME_SAMPLE}
											defaultValue={!!userData?.usernameKanji ? userData.usernameKanji : null}
                    />
                    <InputText
                      title={string.SIGNUP_FURIGANA_TITLE}
                      id="usernameHira"
                      placeholder={string.SIGNUP_FURIGANA_SAMPLE}
											defaultValue={!!userData?.usernameHira ? userData.usernameHira : null}
                    />
                    <InputText
                      title={string.SIGNUP_PHONE_TITLE}
                      id="phoneNumber"
                      placeholder={string.SIGNUP_PHONE_SAMPLE}
											defaultValue={!!userData?.phoneNumber ? userData.phoneNumber : null}
                    />
                    <InputText
                      type={showPassword ? 'text' : 'password'}
                      title={string.SIGNUP_PASSWORD_TITLE}
                      id="password"
                      placeholder={string.SIGNUP_PASSWORD_SAMPLE}
                      iconShow={true}
                      showPassword={showPassword}
                      handleClick={onClick}
											defaultValue={!!userData?.password ? userData.password : null}
                    />
                    <InputText
                      type={showPassword ? 'text' : 'password'}
                      // type={showPassword ? 'hidden' : 'password'}
                      title={string.SIGNUP_CONFIRM_TITLE}
                      id="passwordConfirm"
                      placeholder={string.SIGNUP_CONFIRM_SAMPLE}
                      iconShow={!showPassword}
                      showPassword={showPassword}
                      handleClick={onClick}
											defaultValue={!!userData?.passwordConfirm ? userData.passwordConfirm : null}
                    />
                    <div style={{ paddingTop: '10px', display: 'flex' }}>
											{string.SIGNUP_CONFIRM}
                    </div>
                    <div style={{ paddingTop: '10px', display: 'flex' }}>
											<div style={{ paddingTop: '6px', display: 'flex' }}>
												{`${string.SIGNUP_PRIVACY_CONFIRM}：`}
                      </div>
											<Button
												className="button-privacy"
												onClick={onPolicyClick}
											>{string.CONFIRM}</Button>
											{!!isPolicyChecked && (<div style={{ paddingTop: '6px', display: 'flex', color: 'blue' }}>
												{`${string.SIGNUP_PRIVACY_CONFIRM_OK}`}
                      </div>)}
                    </div>
                    <div style={{ paddingTop: '10px', display: 'flex' }}>
											<div style={{ paddingTop: '6px', display: 'flex' }}>
												{`${string.SIGNUP_TERMS_OF_USE_CONFIRM}：　　　　　　`}
                      </div>
											<Button
												className="button-privacy"
												onClick={onTermsConditionsClick}
											>{string.CONFIRM}</Button>
											{!!isTermsConditionChecked && (<div style={{ paddingTop: '6px', display: 'flex', color: 'blue' }}>
												{`${string.SIGNUP_TERMS_OF_USE_CONFIRM_OK}`}
                      </div>)}
                    </div>
                    <div style={{ paddingTop: '10px', display: 'flex', justifyContent: 'center' }}>
                      <Form.Check
                        type="checkbox"
												label={`${string.SIGNUP_CONFIRM_CHECK}`}
                        checked={termConditionCheck}
												onClick={() => {
													if (!!isPolicyChecked && !!isTermsConditionChecked) {
														if (!!termConditionCheck) {
															setTermConditionCheck(false);
														}
														else {
															setTermConditionCheck(true);
														}
													}
												}}
                      />
                    </div>
                    <div>
                      <Button
												type="submit"
												className="button-submit"
											>
                        {string.SIGNUP_SUBMIT}
                      </Button>
                    </div>
										<div id="formFooter">
											<a className="underlineHover" href={Paths.user.login}>
												<FaChevronLeft />
												{' ' + string.LOGIN}
											</a>
										</div>
                  </>
                )}
                {showForm2 && (
                  <>
                    <InputText
                      title={string.SIGNUP_OTP_TITLE}
                      id="otp"
                      placeholder={string.SIGNUP_OPT_SAMPLE}
                    />
										<div>
											<Button
												type="submit"
												className="button-submit"
												// onClick={onSubmit}
											>
                        {string.SIGNUP_OPT_CONFIRM}
                      </Button>
                    </div>
										<div style={{marginTop:'10px',display:'flex', justifyContent:'left'}}>
											【認証コードについて】
										</div>
										<div style={{display:'flex', justifyContent:'left'}}>
											　・メール送付から5分間有効です。
										</div>
										<div style={{display:'flex', justifyContent:'left'}}>
											　・一度使用すると無効になります。
										</div>
										<div style={{display:'flex', justifyContent:'left'}}>
											　・無効になった場合はアカウント登録を最初から行ってください。
										</div>
                  </>
                )}
                {showForm3 && (
                  <>
                    <h6
                      style={{
                        fontWeight: '600',
                        textAlign: 'left',
                        paddingLeft: '10px',
                        marginTop: '20px',
                        marginBottom: '20px',
												display: 'flex',
												justifyContent: 'center',
                      }}
                    >
                      {string.SIGNUP_FINISH_MESSAGE}
                    </h6>
                    <div>
											<Button
												type="submit"
												className="button-submit"
												// onClick={onSubmit}
											>
                        {string.SIGNUP_FINISH}
                      </Button>
                    </div>
                  </>
                )}
              </Form>
            </div>
          </div>
        </div>
				{showPolicyModal && (
					<Policy
						onBackClick={closePolicyModal}
					/>
					// <PolicyModal
					// 	show={showPolicyModal}
					// 	handleClose={closePolicyModal}
					// />
				)}
				{showTermsConditionsModal && (
					<TermsOfUse
						onBackClick={closeTermsConditionsModal}
					/>
					// <TermsConditionsModal
					// 	show={setShowTermConditionsModal}
					// 	handleClose={closeTermsConditionsModal}
					// />
				)}
      </div>
    </>
  );
};

export default Signup;

/*
	return (
		<>
			<Page
				title={string.SIGNUP}
				body={
					<>
            <Form
              className="_user-info-form"
              style={{ textAlign: 'center' }}
              onSubmit={onSubmit}
            >
              <FormControls
                controls={[
                  {
                    id: 'password',
                    title: string.CURRENT_PASSWORD,
                    type: showPassword ? 'text' : 'password',
                    footer: showPassword ? (
                      <>
                        <ImEye
                          onClick={() => {
                            setShowPassword(false);
                          }}
                        />
                      </>
                    ) : (
                      <>
                        <RiEyeCloseLine
                          onClick={() => {
                            setShowPassword(true);
                          }}
                        />
                      </>
                    ),
                  },
                  {
                    id: 'newPassword',
                    title: string.NEW_PASSWORD,
                    type: showPassword ? 'text' : 'password',
                    footer: showPassword ? (
                      <>
                        <ImEye
                          onClick={() => {
                            setShowPassword(false);
                          }}
                        />
                      </>
                    ) : (
                      <>
                        <RiEyeCloseLine
                          onClick={() => {
                            setShowPassword(true);
                          }}
                        />
                      </>
                    ),
                  },
                  {
                    id: 'newPasswordConfirm',
                    title: string.CONFIRM_NEW_PASSWORD,
                    type: showPassword ? 'text' : 'password',
                    // type: showPassword ? 'hidden' : 'password',
                    footer: showPassword ? (
                      <>
                        <ImEye
                          onClick={() => {
                            setShowPassword(false);
                          }}
                        />
                      </>
                    ) : (
                      <>
                        <RiEyeCloseLine
                          onClick={() => {
                            setShowPassword(true);
                          }}
                        />
                      </>
                    ),
                  },
                ]}
              />
              <Button type="submit">{string.UPDATE}</Button>
            </Form>
					</>
				}
			/>
		</>
	);

*/
